import { AuthAction, AuthActionType } from '../actions';

interface AuthState {
  logged_in: boolean;
  is_hr: boolean;
}

const initialAuthState: AuthState = {
  // logged_in: false,
  logged_in: false, // TODO: for dev purpose
  is_hr: false,
};

const authReducer = (
  state: AuthState = initialAuthState,
  action: AuthAction,
): AuthState => {
  switch (action.type) {
    case AuthActionType.SIGN_IN: {
      return {
        logged_in: true,
        is_hr: action.payload.is_hr,
      };
    }
    case AuthActionType.SIGN_OUT:
      return {
        logged_in: false,
        is_hr: false,
      }; // TODO: do we keep the jwt_token
    case AuthActionType.REFRESH:
      return {
        logged_in: true,
        is_hr: action.payload.is_hr,
      };
    default:
      return state;
  }
};

export default authReducer;
